import React, { useState } from 'react';
import cx from 'classnames';
import './FilterBarLayout.scss';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

function ClearFiltersButton({ items, refine, close }) {
  return (
    <div
      className="filter-btn justify-center flex-1"
      onClick={() => {
        refine(items)
        close(false)
      }}
    >
      Clear Filters
    </div>
  )
}

export function FilterBarLayout({
  regionWidget,
  widgets,
  bottomLeftWidgets,
  bottomRightWidgets,
}) {
  const [openOnMobile, setOpenOnMobile] = useState(false);
  const ClearFilters = connectCurrentRefinements(ClearFiltersButton);

  const handleToggleFilters = () => {
    setOpenOnMobile(!openOnMobile);
    document.querySelector('body').classList.toggle("overflow-hidden")
  }

  const handleSaveFilters = () => {
    setOpenOnMobile(false);
    document.querySelector('body').classList.toggle("overflow-hidden")
  }

  const handleClearFilters = () => {
    setOpenOnMobile(false);
    document.querySelector('body').classList.toggle("overflow-hidden")
  }

  return (
    <div>
      <div
        className={cx(
          'filter-bar-layout',
          openOnMobile && 'filter-bar-layout--open'
        )}
      >
        <div className="flex">
          {/* Filter button (mobile only) */}
          <div
            className={cx(
              'mt-6 lg:mt-0 flex-1 lg:flex',
              openOnMobile ? 'hidden' : 'flex flex-col gap-4 w-full'
            )}
          >
            {regionWidget}

            <div
              onClick={() => handleToggleFilters()}
              className="filter-btn w-full justify-center lg:hidden text-honestly-white"
            >
              <i className="fas fa-filter mr-2" />
              Filters
            </div>
          </div>
        </div>

        <div
          className={cx(
            'lg:flex flex-wrap content-start overflow-y-auto lg:overflow-visible mt-8 lg:mt-4 gap-4 w-full',
            openOnMobile ? 'flex' : 'hidden'
          )}
        >
          <span className="lg:hidden ml-auto "><i className="fas fa-times mr-4 mb-6 cursor-pointer" onClick={() => handleClearFilters()}/></span>
          {widgets.props.children}
        </div>
        {/* Save/Clear buttons (mobile only) */}
        <div className={cx('gap-4 mt-4', openOnMobile ? 'flex' : 'hidden')}>
          <div
            className="filter-btn justify-center flex-1"
            onClick={() => handleSaveFilters()}
          >
            Save Filters
          </div>
        <ClearFilters close={handleClearFilters}/>
        </div>
      </div>
      <div className="flex justify-between mt-4">
        <div>{bottomLeftWidgets}</div>
        <div className="flex">{bottomRightWidgets}</div>
      </div>
    </div>
  );
}
